export const BUTTON_DISABLED_OPACITY = 0.32;
export const BUTTON_HOVER_BRIGHTNESS = 0.65;

export const SWALLOWED_PROPS = [
  'link',
  'small',
  'large',
  'giant',
  'spacey',
  'display',
  'outline',
  'success',
  'danger',
  'warning',
  'secondary',
  'white',
  'disabled',
  'submitting',
  'css',
];
